import './_product-card-quick-shop-button.scss';

export default () => {};
